export default function NoItemsLabel({ title }: { title: string }) {
  return (
    <div className="text-center text-red-400 bg-[#474A4D] rounded-[5px] py-5 px-3">
      <p>{title}</p>
    </div>
  );
}
